const DEBOUNCE_WAIT = 500;

export { DEBOUNCE_WAIT };
